<template>
	<FilterComponent
		:title="'Movimentação'"
		:open="openFilter"
		:fields="filterFields"
		@apply-filters="handleFilters"
		@update-open="openFilter = false"
    />

	<MovimentacaoForm
		:title="'Movimentação'"
		:open="openNew"
		@update-open="openNew = false"
		@data="onSendFormData"
	/>

	<MovimentacaoListing
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "[]"
		:previous = "previous"
		:next = "next"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:editFormData= "editFormData"
		@new="openNew = true"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@find-by-field= "filtered"
		@clean-filter= "cleanFilter"
		@send-form-data= "onSendFormData"
		@view-confirmation= "getViewData"
		@filter="openFilter = true"
		@delete-data-id="handleDelete"
		@cancel-data-id="handleCancel"
	/>
	<CommonLoading
		v-if="loading"
	/>
</template>
<script>
import MovimentacaoListing from '@/views/insideviews/movimentacao/MovimentacaoListing.vue';
import { pageVariables } from '@/views/insideviews/movimentacao/PageVariablesMovimentacao';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";
import Swal from "sweetalert2";
import CommonLoading from '@/components/generalcomponents/CommonLoading.vue';
import MovimentacaoForm from './MovimentacaoForm.vue';
import ControleMovimentosRepository from '@/services/ControleMovimentosRepository.vue';

export default {
	name: 'MovimentacaoView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.page)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			viewId: null,
			controleData:[],
			next: '',
			loading: false,
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			editFormData:{},
			openFilter: false,
			openNew: false,
			filters: [],
			filterFields: [
			],
			onlineUser: JSON.parse(window.localStorage.getItem("myUser"))
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			console.log(page)
			this.loading = true; 
			const controleRepo = new ControleMovimentosRepository();
			try {
				const response = await controleRepo.getControles(this.onlineUser.token,page);
				if (response?.status  === 200) {
					this.data = response.data.data;
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

					if (response.data.next_page_url) {
						this.next = response.data.next_page_url;
					}else{
						this.next = ""
					}
					if (response.data.prev_page_url) {

						this.previous = response.data.prev_page_url;
					}else{
						this.previous = ""
					}
					this.loading = false; 

				}
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error); 
			}
		},
		novaEntrada(){
			this.openNew = true;
		},
		async onSendFormData(data){
			this.loading = true; 
			const controleRepo = new ControleMovimentosRepository();
			try {
				const response = await controleRepo.createControle(this.pageCreateMov,data,this.onlineUser.token);
				if (response?.status === 200) {
					this.pageData(this.page);
					this.mostrarAlerta();
					this.loading = false; 
					this.openNew = false;
				} else {
					this.error = response?.message;
					this.mostrarAlertaErro(this.error);
					this.pageData(this.page);
					this.loading = false;
					this.openNew = false;
				}
			} catch (error) {
				this.pageData(this.page);
				this.loading = false;
				this.openNew = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}	
		},
		async handleDelete(id){
			this.loading = true;
			const controleRepo = new ControleMovimentosRepository();
			try {
				const response = await controleRepo.fecharControle(this.onlineUser.token, id);
				if (response?.status === 200) {
					this.pageData(this.page);
					this.mostrarAlerta();
				} else {
					this.mostrarAlertaErro(response?.data?.message || 'Erro ao fechar movimentação');
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				this.mostrarAlertaErro(error);
				handleUnauthorized(error);
			}
		},
		async handleCancel(id){
			const { isConfirmed } = await Swal.fire({
				title: 'Tem certeza?',
				text: "Deseja realmente CANCELAR esta movimentação? Esta ação é irreversível.",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#d33',
				cancelButtonColor: '#3085d6',
				confirmButtonText: 'Sim, cancelar!',
				cancelButtonText: 'Manter prévia'
			});

			if (isConfirmed) {
				this.loading = true;
				const controleRepo = new ControleMovimentosRepository();
				try {
					const response = await controleRepo.cancelarControle(this.onlineUser.token, id);
					if (response?.status === 200) {
						this.pageData(this.page);
						this.mostrarAlerta();
					} else {
						this.mostrarAlertaErro(response?.data?.message || 'Erro ao cancelar movimentação');
					}
					this.loading = false;
				} catch (error) {
					this.loading = false;
					this.mostrarAlertaErro(error);
					handleUnauthorized(error);
				}
			}
		},
		getViewData(data){
			console.log(data)
			this.$router.push({
				name: 'movimentacao.show',
				params: { id: data.id },
				state: { controleData: JSON.parse(JSON.stringify(data)) }
			})
		},
		goTo(number){
			this.pageData(this.planosFilterPage+"?page="+number)
		},
		filtered(filteredData){
			const key = this.seachFilterKey;
			const value = filteredData;
			if (key) {
				this.pageData(this.planosFilterPage+"?"+key+'='+value);
			}
		},
		cleanFilter(){
			this.pageData(this.planosFilterPage)	
		},

		handleFilters(rawFilters){
			console.log(rawFilters)
			this.filters = rawFilters;
			this.openFilter = false;
			this.pageData(this.planosFilterPage);
		},

		mostrarAlerta() {
			Swal.fire({
				icon: 'success',
				title: 'Sucesso!',
				text: 'A operação foi concluída com sucesso.',
				confirmButtonColor: '#3085d6', 
			});
		},

		mostrarAlertaErro(message) {
			Swal.fire({
				icon: 'error',
				title: 'Erro!',
				text: message,
				confirmButtonColor: '#3085d6', 
			});
		},
	},
	components:{
		MovimentacaoListing,
		MovimentacaoForm,
		FilterComponent,
		CommonLoading
	},
	setup() {
	return {
	}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
